import { Vue, Component, Prop } from 'vue-property-decorator';
import { PimcoreLayoutInput } from '@/types/entity';

@Component
export default class LayoutOptionsMixin extends Vue {
  @Prop()
  layoutOptions!: PimcoreLayoutInput;

  get layoutLabel(): string {
    return this.layoutOptions?.title || '';
  }

  get layoutVariants(): any[] {
    return this.layoutOptions?.options || [];
  }

  get yesLabel(): string {
    return this.layoutOptions?.yesLabel || this.$t('Yes').toString();
  }

  get noLabel(): string {
    return this.layoutOptions?.noLabel || this.$t('No').toString();
  }
}
